/* eslint-disable prettier/prettier */
declare const bootstrap: any;
declare var document: any;

export class MsgService {

    constructor() { }

    success(msg: string, title: string = 'Success') {
        this.add('success', title, msg);
    }

    info(msg: string, title: string = 'Information') {
        this.add('info', title, msg);
    }

    warning(msg: string, title: string = 'Warning') {
        this.add('warn', title, msg);
    }

    error(msg: string, title: string = 'Error') {
        this.add('error', title, msg);
    }

    add(severity: string, summary: string, detail: string) {
        // detail = Config.labels[detail] || detail;
        // this.messageService.add({ severity, summary, detail });
        this.clear();
        let content = `
            <div class="toast align-items-center text-bg-${severity} border-0" role="alert" aria-live="assertive" aria-atomic="true">
                <div class="d-flex">
                    <div class="toast-body">${detail}</div>
                    <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
            </div>`;
        let div = document.createElement('div');
        div.className = 'toast-container position-fixed bottom-0 end-0 p-3';
        div.innerHTML = content;
        document.body.appendChild(div);
        let toast = new bootstrap.Toast(div.querySelector('.toast'));
        toast.show();
    }

    clear() {
        let div = document.querySelector('.toast-container');
        if (div) {
            div.remove();
        }
    }
}
